import * as R from 'ramda';
import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
import * as mainStyles from './styles.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
function getModalWindowStyles(deviceType, size) {
  var deviceStyles = getDeviceStyles(deviceType, size);
  return mergeStyles(mainStyles, deviceStyles);
}
export var getStyles = R.memoizeWith(getDeviceStylesIdentity, getModalWindowStyles);